import React, { useCallback, useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FaBoxOpen } from 'react-icons/fa';
import { MdKeyboardBackspace } from 'react-icons/md';

import { IRouterParams } from 'shared/interfaces';

import {
  createFamilia,
  getFamilia,
  updateFamilia,
} from 'services/api/produtoFamilia';

import { useToast } from 'contexts';

import * as C from 'components';
import * as S from './styles';

import { IProdutoFamilia, IProdutoFamiliaForm } from '../interfaces';

const schema = Yup.object().shape({
  nome: Yup.string().required('Descrição obrigatória'),
  foto_upload: Yup.mixed(),
});

export const FamiliasForm: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();

  const { id } = useParams<IRouterParams>();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm<IProdutoFamiliaForm>({
    defaultValues: {
      nome: '',
    },
    resolver: yupResolver(schema),
  });

  const [loading, setLoading] = useState(false);
  const [familia, setFamilia] = useState<IProdutoFamilia>();

  useEffect(() => {
    if (id) {
      getFamilia(id).then((data) => {
        setFamilia(data);

        reset(data);
      });
    }
  }, [id, reset]);

  const onSubmit = useCallback(
    async (data: IProdutoFamilia) => {
      try {
        setLoading(true);

        if (id) {
          const response = await updateFamilia(id, data);

          if (response) {
            addToast({
              type: 'success',
              title: 'Atualizado',
              description: 'Atualizado com sucesso',
            });

            history.push('/produto/familias');
          }
        } else {
          await createFamilia(data);

          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Salvo com sucesso',
          });

          reset();

          history.push('/produto/familias');
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Ops, Erro',
          description: 'Ocorreu um erro ao inserir um novo registro',
        });
      } finally {
        setLoading(false);
      }
    },

    [addToast, history, id, reset],
  );

  return (
    <S.Container>
      <C.HeaderBackground>
        <S.HeaderPageDatail>
          <S.BackLink>
            <Link to="/produto/familias">
              <MdKeyboardBackspace size={24} color="#fff" />
              Familia
            </Link>
          </S.BackLink>

          <C.HeaderInfo
            title={id ? `Editando: ${familia?.nome}` : 'Nova Familia'}
            icon={FaBoxOpen}
          />
        </S.HeaderPageDatail>
      </C.HeaderBackground>

      <S.Panel>
        <form onSubmit={handleSubmit(onSubmit)}>
          <C.Upload
            {...register('foto_upload')}
            imageUrl={familia?.foto_url}
            fileSelected={watch('foto_upload')}
          />

          <C.FormGroup>
            <C.Label>Descrição</C.Label>
            <C.Input
              type="text"
              {...register('nome')}
              errors={errors.nome}
              name="nome"
              placeholder="Descrição"
            />
          </C.FormGroup>

          <C.Button
            variant="primary"
            disabled={loading}
            loading={loading}
            type="submit"
            title="Salvar"
          >
            Salvar
          </C.Button>
        </form>
      </S.Panel>
    </S.Container>
  );
};
